const formatSessionDuration = (duration: number) => {
  const durationRounded = Math.round(duration);

  if (durationRounded <= 60) {
    return `${durationRounded} min`;
  }

  const hours = Math.floor(durationRounded / 60);
  const minutes = durationRounded % 60;

  if (minutes === 0) {
    return `${hours} h`;
  }

  return `${hours} h ${minutes} min`;
};

export default formatSessionDuration;
